import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bellevueNeConfig } from "./data";

export default function BellevueNePage() {
  return <CityPageTemplate config={bellevueNeConfig} />;
}